import React from 'react';
import ReactDOM from 'react-dom';

//component
import DisplayInformationPopUpModal from  '@/components/modals/content/DisplayInformationPopUpModal';



const DisplayInformationPopUpModalPortal = () => { 
    const targetContainer = document.getElementById('react-display-information-modal-container');

    if (!targetContainer) {
        return null;
    }
    
    return ReactDOM.createPortal(
      <DisplayInformationPopUpModal />, targetContainer
    );
}


export default DisplayInformationPopUpModalPortal;